package com.fabiorosati.components.sections

import androidx.compose.runtime.*
import com.fabiorosati.SubheadlineTextStyle
import com.fabiorosati.common.Language
import com.fabiorosati.common.getTranslations
import com.fabiorosati.components.widgets.ClickableImage
import com.fabiorosati.components.widgets.VerticalSpacer
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.dom.Span


@Composable
fun NextShowsSection(
    id: String,
    title: String,
    language: Language,
    onNotifyTop: () -> Unit = {},
) {
    HomeSection(
        id = id,
        title = title,
        backgroundImage = "/valkanorr-shows.png",
        onNotifyTop = { onNotifyTop() },
    ) {
        Column(
            modifier = SubheadlineTextStyle.toModifier()
                .fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(0.5.cssRem)
        ) {
//            SpanText(language.getTranslations().nextShowsText)
//            VerticalSpacer(3.cssRem)
            LiveShow(
                event = "Insubria Festival",
                date = "25.26.27 Aprile 2025",
                location = "Marcallo con Casone (MI), Italy",
                link = "https://www.insubriafestival.org/"
            )
            LiveShow(
                event = "Steam Party",
                date = "10.11 Maggio 2025",
                location = "San Marino",
                link = "https://www.sanmarinocomics.com/content/steam-party-2025"
            )
            LiveShow(
                event = "Torneo di Maggio",
                date = "24.25 Maggio 2025",
                location = "Cuorgnè (TO), Italy",
                link = "https://www.torneodimaggio.com/"
            )
            LiveShow(
                event = "Beltane Pagan Festival",
                date = "30 Maggio 2025",
                location = "Masserano (BI), Italy",
                link = "https://beltanefestival.it/"
            )
            LiveShow(
                event = "In Nomine Matris",
                date = "13.14.15 Giugno 2025",
                location = "Capo di Ponte (BS), Italy",
                link = "https://www.instagram.com/innomine_matris/?hl=en"
            )
            LiveShow(
                event = "Festa privata",
                date = "12 Luglio 2025",
                location = "",
                link = ""
            )
            LiveShow(
                event = "Giorni medioevali al Castel Tasso",
                date = "18.19 Luglio 2025",
                location = "Vipiteno (BZ), Italy",
                link = "https://www.vipiteno.com/it/attivita/citta-e-cultura/castel-tasso.html"
            )
            LiveShow(
                event = "Montelago Celtic Festival",
                date = "9 Agosto 2025",
                location = "Serravalle di Chienti (MC), Italy",
                link = "https://www.montelagocelticfestival.it/"
            )
            LiveShow(
                event = "Druidia",
                date = "21 Agosto",
                location = "Cesenatico (FC), Italy",
                link = "https://www.druidia.it/"
            )
            LiveShow(
                event = "Festiwal Mitologii Słowiańskiej",
                date = "23.24 Agosto 2025",
                location = "Owidz, Poland",
                link = "https://www.instagram.com/muzeummitologiislowianskiej/"
            )
            LiveShow(
                event = "Abruzzo Irish Festival",
                date = "29 Agosto 2025",
                location = "Notaresco (TE), Italy",
                link = "https://www.abruzzoirishfestival.it/"
            )
            LiveShow(
                event = "San Marino Comics",
                date = "30.31 Agosto 2025",
                location = "San Marino",
                link = "https://www.sanmarinocomics.com"
            )
            LiveShow(
                event = "Axa Briga",
                date = "6.7 Settembre 2025",
                location = "Settimo Rottaro (TO), Italy",
                link = "https://www.axabriga.it/"
            )
            LiveShow(
                event = "Mutina Boica",
                date = "12 Settembre 2025",
                location = "Modena (MO), Italy",
                link = "https://cronoeventi.it/"
            )
            LiveShow(
                event = "Roi de l'Oiseau",
                date = "19.20 Settembre 2025",
                location = "Le Puy-en-Velay, France",
                link = "https://www.roideloiseau.com/"
            )
            LiveShow(
                event = "Capodanno Celtico",
                date = "31 Ottobre 2025",
                location = "Busto Arsizio (VA), Italy",
                link = "https://www.gensdys.it/calendario_gensdys/"
            )
            LiveShow(
                event = "Birreria Valhalla",
                date = "20 Dicembre 2025",
                location = "Asola (MN), Italy",
                link = "https://www.birreriavalhalla.it/"
            )
            VerticalSpacer(1.cssRem)
            Span {
                SpanText(language.getTranslations().nextShowsBook + " ")
                Link(
                    path = "/#contacts",
                    text = language.getTranslations().contactUs,
                    variant = UncoloredLinkVariant
                )
            }
        }
    }
}

@Composable
private fun LiveShow(
    event: String,
    date: String,
    location: String,
    link: String,
) {
    var hovering by remember { mutableStateOf(false) }
    val contentModifier = Modifier
        .onMouseOver { hovering = true  }
        .onMouseOut { hovering = false }
        .cursor(Cursor.Pointer)
        .fillMaxWidth()
        .backgroundColor(Colors.Black.copy(alpha = if(hovering) 100 else 150))
        .padding(1.1.cssRem)

    SmallLiveShow(
        modifier = contentModifier.displayUntil(Breakpoint.MD),
        event = event,
        date = date,
        location = location,
        link = link
    )

    MediumLiveShow(
        modifier = contentModifier.displayIfAtLeast(Breakpoint.MD),
        event = event,
        date = date,
        location = location,
        link = link
    )
}

@Composable
private fun SmallLiveShow(
    modifier: Modifier = Modifier,
    event: String,
    date: String,
    location: String,
    link: String,
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column {
            SpanText(date)
            SpanText(event)
            SpanText(location)
        }
        Spacer()
        ClickableImage(
            src = "/icons/link-white.svg",
            hoverSrc = "/icons/link-primary.svg",
            description = "link icon",
            path = link
        )
    }
}

@Composable
private fun MediumLiveShow(
    modifier: Modifier = Modifier,
    event: String,
    date: String,
    location: String,
    link: String,
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(
            modifier = Modifier.width(25.cssRem)
        ) {
            SpanText(date)
            SpanText(event)
        }
        SpanText(location)
        Spacer()
        ClickableImage(
            src = "/icons/link-white.svg",
            hoverSrc = "/icons/link-primary.svg",
            description = "link icon",
            path = link
        )
    }
}